import { render, staticRenderFns } from "./ExpressSingleNumChart.vue?vue&type=template&id=618616a6&scoped=true&"
import script from "./ExpressSingleNumChart.vue?vue&type=script&lang=js&"
export * from "./ExpressSingleNumChart.vue?vue&type=script&lang=js&"
import style0 from "./ExpressSingleNumChart.vue?vue&type=style&index=0&id=618616a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618616a6",
  null
  
)

export default component.exports